export async function getData() {
    const response = await fetch('/api/bracket/getData');
    return await response.json();
}